import rsnippets from '@/utils/rich-snippets.js'

export default {
  methods: {
    setTitleAndMetas(anim) {
      this.$store.commit('setShowTestimonialButton', this.details.has_quotes)
      this.$store.commit('setSimilars', { related: this.details.related, artist: this.artist })
      let title = 'IllustrationX - ' + this.artist.formatted_name + ' portfolio'
      if(anim) title = 'AnimationX - ' + this.artist.formatted_name + ' portfolio'
      
      let rs = rsnippets.getRichSnippet(this.artist, this.details, this.$route.path, this.$nippets)
      if(this.details.meta_title && (this.details.meta_title !== 'My Homepage')  && (this.details.meta_title !== 'undefined')) {
        title = this.details.meta_title
      }
      let desc = this.details.meta_description
      if((!desc) || (desc === 'undefined')) {
        desc = 'Check out ' + this.artist.formatted_name + '\'s illustration portfolio.'
      }
      this.$k.setMetatags(title, desc, rs)
      let md = desc
      let tt = title
      if(this.details.overview) {
        md = this.$k.stripHtml(this.details.overview)
        if(md.length > 200){
          md = md.substring(0, 200)
        }
      }
      if(this.details.subhead) {
        tt = this.details.subhead.replace(/"/g, '')
        tt = this.artist.formatted_name + '\'s Portfolio - ' + tt
      }
      let nps = this.artist.formatted_name.split(' ')
      this.$k.setTwitterMetas(tt, null, false, md, nps[0], nps[nps.length - 1])
    }
  }
}